module.exports = __webpack_public_path__ + "img/media-img-13.2db6eb51.png";